import { Amplify } from "aws-amplify";
import { env } from "@/config/env";

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.cognito.userPoolId,
        userPoolClientId: env.cognito.clientId,
        loginWith: { email: true },
      },
    },
  });
}
